export const formatString = (str: string) => (str ? str.replace(/\s+/g, '-').toLowerCase() : str)
